<template>
	<v-dialog max-width="800" v-model="show" persistent>
		<v-card>
			<v-card-text>
				<v-layout row wrap>
					<v-flex xs12 ml-2 mb-4 class="title">
						{{ title }}
					</v-flex>
					<v-flex xs12>
						<InputField
							:hint="$t('labels.separation')"
							:label="$t('fields.emailAddress')"
							v-model="emails"></InputField>
					</v-flex>
					<v-flex xs12>
						<InputField
							:hint="$t('labels.separation')"
							:label="$t('fields.cc')"
							v-model="cc"></InputField>
					</v-flex>
					<v-flex xs12>
						<InputField
							:hint="$t('labels.separation')"
							:label="$t('fields.bcc')"
							v-model="bcc"></InputField>
					</v-flex>
					<v-flex xs12>
						<InputField
							:label="$t('fields.subject')"
							v-model="subject"></InputField>
					</v-flex>
					<v-flex xs12>
							<TextArea
								:rows="15"
								:label="$t('fields.message')"
								v-model="message"></TextArea>
					</v-flex>
<!--					<v-flex xs12>-->
<!--						<Upload v-model="newFile"/>-->
<!--					</v-flex>-->
<!--					<v-flex :key="key" v-for="(file, key) in attachments" v-show="file.send" xs12>-->
<!--						<v-btn @click="removeAttachment(key)" icon>-->
<!--							<v-icon small>fa-trash</v-icon>-->
<!--						</v-btn>-->
<!--						<a :href="file.link" target="_blank">-->
<!--							{{ file.original_name }}-->
<!--						</a>-->
<!--					</v-flex>-->
				</v-layout>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="reset">{{ $t('buttons.close') }}</v-btn>
				<v-btn @click="save">{{ $t('buttons.send') }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import InputField from "../trinkets/InputField";
	import TextArea from "../trinkets/TextArea";
	import Upload from "../trinkets/Upload";

	export default {
		name: "Email",
		props: ['show', 'entity', 'objectId'],
		components: {
			InputField,
			TextArea,
			Upload
		},
		data: function () {
			return {
				newFile: {
					name: '',
					link: '',
					original_name: ''
				},
				emails: '',
				cc: '',
				bcc: this.$getSettings('DEFAULT_BCC'),
				subject: '',
				message: '',
				attachments: []
			}
		},
		computed: {
			title() {
				if (this.entity == 'invoices') {
					return this.$t('labels.invoicesEmailPopup');
				}
				if (this.entity == 'tours-groups') {
					return this.$t('labels.toursGroupsEmailPopup');
				}
				if (this.entity == 'tours-groups-guests') {
					return this.$t('labels.toursGroupsGuestsEmailPopup');
				}
				return '';
			}
		},
		watch: {
			newFile: {
				handler: function () {
					if (this.newFile.link != '') {
						let newAttachment = JSON.parse(JSON.stringify(this.newFile));
						newAttachment['send'] = true;
						var moment = require('moment');
						newAttachment['time'] = moment().format('D.M.YYYY. HH:mm:ss');
						newAttachment['user'] = {
							id: this.$myStore.state.user.id,
							first_name: this.$myStore.state.user.first_name,
							last_name: this.$myStore.state.user.last_name
						};
						this.attachments.push(newAttachment);
						this.newFile = {
							name: '',
							link: '',
							original_name: ''
						};
					}
				},
				deep: true
			},
			show: function () {
				let vm = this;
				if (this.entity == 'invoices') {
					this.$APICall('get', 'invoices/' + this.objectId, {}, (data, success) => {
						if (success) {
							vm.message = data.email_text;
							vm.subject = data.email_subject;
							vm.emails = data.new_subject_data.email;
						}
					}, false);
				}
				if (this.entity == 'tours-groups') {
					this.$APICall('get', 'tours-groups/' + this.objectId, {}, (data, success) => {
						if (success) {
							vm.message = data.email_text;
							vm.subject = data.email_subject;
							vm.emails = data.email_recipients;
						}
					}, false);
				}
				if (this.entity == 'tours-groups-guests') {
					this.$APICall('get', 'tours-groups-guests/' + this.objectId, {}, (data, success) => {
						if (success) {
							vm.message = data.email_text;
							vm.subject = data.email_subject;
							vm.emails = data.person.email;
						}
					}, false);
				}
			}
		},
		methods: {
			reset() {
				this.emails = '';
				this.cc = '';
				this.bcc = '';
				this.subject = '';
				this.message = '';
				this.attachments = [];
				this.$emit('callback');
			},
			save() {
				let vm = this;
				this.emails = this.emails.split(' ').join('');
				let emails = this.emails.split(';');
				let term = true;
				for (let email of emails) {
					if (!this.$checkEmail(email)) {
						term = false;
					}
				}
				if (term) {
					let payLoad = {
						id: this.objectId,
						destination: this.emails,
						cc: this.cc,
						bcc: this.bcc,
						subject: this.subject,
						message: this.message,
						attachments: this.attachments
					}
					this.$APICall('post', this.entity + '/' + this.objectId + '/email', payLoad, (data, success) => {
						if (success) {
							vm.$notify(this.$t('alerts.emailSent'));
							this.$emit('callback');
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					});
				} else {
					this.$alert(this.$t('alerts.recipientsError'));
				}
			},
			removeAttachment(key) {
				let vm = this;
				this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
					if (result) {
						vm.attachments.splice(key, 1);
					}
				});
			}
		}
	}
</script>

<style scoped>

</style>
